import React from 'react';

const Title = ({ children }) => (
  <p className="t-font-bold t-uppercase t-text-3xl">
    {children}
  </p>
)

export default Title;
